import React, {useState, useEffect} from "react";

import { DatePicker, Select, Table, Button, Tooltip, Modal } from "antd";
import { PlayCircleOutlined } from '@ant-design/icons';

import { postData,getData } from '../../config/api-connect';

import styled from "styled-components";
import moment from 'moment';

function Revenue() {

  const { MonthPicker } = DatePicker;
  const { Option } = Select;

  const [selectedMonth, setSelectedMonth] = useState(moment());
  const [selectedCity, setSelectedCity] = useState('Bangalore');
  const [summaryData, setSummaryData] = useState([])
  const [summaryLoader, setSummaryLoader] = useState(true);
  const [selectedVenueID, setSelectedVenueID] = useState([])
  const [selectedVenueName, setSelectedVenueName] = useState("");
  const [openPopup, setOpenPopup] = useState(false)
  const [taskMonth, setTaskMonth] = useState(moment()); 

  useEffect(() => {
    get_revenue_summary()
  },[selectedMonth,selectedCity])
  
  const cityOptions = [
    "Bangalore",
    "Kerala",
    "Hyderabad",
    "Qatar",
    "UAE",
    "Kuwait",
    "Poland",
    "France",
    "Germany",
    "Thailand",
  ];

  const get_revenue_summary = () => {
    setSummaryLoader(true)

    var month = selectedMonth.format('MM')
    var year = selectedMonth.format('YYYY')

    getData(`/finance/get_venue_wise_revenue_summary/?month=${month}&year=${year}&city_name=${selectedCity}`)
    .then(response =>{
      setSummaryData(response.result)
      setSummaryLoader(false)
    })
    .catch(error => {
      setSummaryLoader(false)
      alert(error.message);
    });
  }

  const columns = [
    {
      title: "Venue",
      dataIndex: "venue",
    },
    
    ...(selectedCity === "Kerala"
      ? [{
          title: "City",
          dataIndex: "city",
          align: "center",
        }]
      : []),
    {
      title: "Location",
      dataIndex: "location",
      align: "center"
    },
    {
      title: "Revenue",
      dataIndex: "revenue",
      align: "center",
      render: (value) => Math.round(value).toLocaleString("en-IN"),
    },
    {
      title: "Action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Run revenue task">
          <Button
            type="default"
            icon={<PlayCircleOutlined />}
            onClick={() => openRevenueTaskModal(record)}
          />
        </Tooltip>
      ),
    }
  ]

  const openRevenueTaskModal = (record) => {
    setSelectedVenueID(record.venue_id);
    setSelectedVenueName(record.venue);
    setTaskMonth(selectedMonth || moment());
    setOpenPopup(true);
  };

  const handleCloseModal = () => {
    setOpenPopup(false);
    setSelectedVenueID(null);
    setSelectedVenueName("");
  };

  const runRevenueTask = () => {

    var month = selectedMonth.format('MM')
    var year = selectedMonth.format('YYYY')

    postData('/finance/run_revenue_task/', {'venue_id': selectedVenueID, 'month': month, 'year': year })
    .then(response =>{
      handleCloseModal();
      if(response.success){
        get_revenue_summary()
        Modal.success({
          content: response.message,
        });
      }
      else{
        Modal.error({
          content: response.message,
        });
      }
    })
    .catch(error => {
      console.log(error.message);
    });
  }

  return (
    <div style={{ padding: 20 }}>
      <PageHeader>
        <PageTitle>Revenue Summary</PageTitle>
        
        <RightActions>
          <Select
            placeholder="Select City"
            style={{ width: 160 }}
            value={selectedCity}
            onChange={(value) => setSelectedCity(value)}
          >
            {cityOptions.map((city) => (
              <Option key={city} value={city}>
                {city}
              </Option>
            ))}
          </Select>

          <MonthPicker
            value={selectedMonth}
            onChange={(value) => setSelectedMonth(value)}
            format="MMMM YYYY"
            allowClear={false}
            style={{ width: 160 }}
            disabledDate={(current) =>
              current && current > moment().endOf("month")
            }
          />
        </RightActions>
      </PageHeader>

      <div className="summary-table-wrapper">
        <Table 
          columns={columns} 
          dataSource={summaryData} 
          pagination={false}
          bordered={false}
          loading={summaryLoader}
        />
      </div>

      <Modal
        open={openPopup}
        title={
          <div>
            Run Revenue Task – <b>{selectedVenueName}</b>
          </div>
        }
        onCancel={handleCloseModal}
        footer={[
          <Button key="cancel" onClick={handleCloseModal}>
            Cancel
          </Button>,
          <Button
            key="run"
            type="primary"
            onClick={runRevenueTask}
          >
            Run Revenue Task
          </Button>,
        ]}
      >
        <div style={{ marginTop: 10 }}>
          <div style={{ marginBottom: 8, fontWeight: 500 }}>
            Select Month
          </div>
          <MonthPicker
            value={taskMonth}
            onChange={(value) => setTaskMonth(value)}
            format="MMMM YYYY"
            style={{ width: "100%" }}
            allowClear={false}
          />
        </div>
      </Modal>

      
    </div>
  );
}

export default Revenue;

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  padding: 15px 20px;
  border-radius: 6px;
  margin-bottom: 20px;
`;

export const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const PageTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1565c0;
`;